export var LearningManagementSystems;
(function (LearningManagementSystems) {
    LearningManagementSystems["GC"] = "GC";
})(LearningManagementSystems || (LearningManagementSystems = {}));
export var LearningManagementSystemRoles;
(function (LearningManagementSystemRoles) {
    LearningManagementSystemRoles["STUDENT"] = "STUDENT";
    LearningManagementSystemRoles["TEACHER"] = "TEACHER";
})(LearningManagementSystemRoles || (LearningManagementSystemRoles = {}));
export var RosterImportState;
(function (RosterImportState) {
    RosterImportState["BLOCKED"] = "BLOCKED";
    RosterImportState["INVITED"] = "INVITED";
    RosterImportState["JOINED"] = "JOINED";
    RosterImportState["NOT_ENROLLED"] = "NOT_ENROLLED";
    RosterImportState["REMOVED"] = "REMOVED";
})(RosterImportState || (RosterImportState = {}));
export var ImportSourceType;
(function (ImportSourceType) {
    ImportSourceType["CLEVER"] = "clever";
    ImportSourceType["CLASS_LINK"] = "classlink";
})(ImportSourceType || (ImportSourceType = {}));
export var ClassroomStatus;
(function (ClassroomStatus) {
    ClassroomStatus["ACTIVE"] = "ACTIVE";
    ClassroomStatus["ARCHIVED"] = "ARCHIVED";
})(ClassroomStatus || (ClassroomStatus = {}));
export var ClassroomType;
(function (ClassroomType) {
    /** Allowed classrooms for Top Down organization users */
    ClassroomType["TRUE"] = "TRUE";
    /** Allowed classrooms for Bottom up organization users */
    ClassroomType["RESTRICTED"] = "RESTRICTED";
    /** Allowed classrooms for users on their personal account */
    ClassroomType["UNRESTRICTED"] = "UNRESTRICTED";
    /** Not allowed classrooms */
    ClassroomType["NONE"] = "NONE";
})(ClassroomType || (ClassroomType = {}));
export var SubjectTypes;
(function (SubjectTypes) {
    SubjectTypes["noSubject"] = "";
    SubjectTypes["allsubjects"] = "allsubjects";
    SubjectTypes["careersTechnicalEducation"] = "careersTechnicalEducation";
    SubjectTypes["computerScience"] = "computerScience";
    SubjectTypes["english"] = "english";
    SubjectTypes["math"] = "math";
    SubjectTypes["otherLanguages"] = "otherLanguages";
    SubjectTypes["others"] = "others";
    SubjectTypes["science"] = "science";
    SubjectTypes["socialStudies"] = "socialStudies";
    SubjectTypes["visualPerformingArts"] = "visualPerformingArts";
})(SubjectTypes || (SubjectTypes = {}));
export var ClassroomRole;
(function (ClassroomRole) {
    ClassroomRole["STUDENT"] = "STUDENT";
    ClassroomRole["TEACHER"] = "TEACHER";
})(ClassroomRole || (ClassroomRole = {}));
export var BlockApiSuccessResponses;
(function (BlockApiSuccessResponses) {
    BlockApiSuccessResponses["REMOVE_STUDENT_SUCCESS"] = "REMOVE_STUDENT_SUCCESS";
    BlockApiSuccessResponses["BLOCK_STUDENT_SUCCESS"] = "BLOCK_STUDENT_SUCCESS";
    BlockApiSuccessResponses["UNBLOCK_STUDENT_SUCCESS"] = "UNBLOCK_STUDENT_SUCCESS";
    BlockApiSuccessResponses["DELETE_DOMAIN_MAPPING_ACCEPTED"] = "DELETE_DOMAIN_MAPPING_ACCEPTED";
    BlockApiSuccessResponses["REMOVE_TEACHER_SUCCESS"] = "REMOVE_TEACHER_SUCCESS";
})(BlockApiSuccessResponses || (BlockApiSuccessResponses = {}));
export var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["OWNER"] = "OWNER";
    MembershipStatus["ACTIVE"] = "ACTIVE";
    MembershipStatus["INACTIVE"] = "INACTIVE";
    MembershipStatus["INVITED"] = "INVITED";
    MembershipStatus["IN_REVIEW"] = "IN_REVIEW";
    MembershipStatus["DECLINED"] = "DECLINED";
    MembershipStatus["NOT_A_MEMBER"] = "NOT_A_MEMBER";
})(MembershipStatus || (MembershipStatus = {}));
export var CoTeacherEligibilityStatus;
(function (CoTeacherEligibilityStatus) {
    CoTeacherEligibilityStatus["ALLOWED"] = "ALLOWED";
    CoTeacherEligibilityStatus["NOT_ALLOWED"] = "NOT_ALLOWED";
})(CoTeacherEligibilityStatus || (CoTeacherEligibilityStatus = {}));
export var CoTeacherIneligibilityReason;
(function (CoTeacherIneligibilityReason) {
    CoTeacherIneligibilityReason["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    CoTeacherIneligibilityReason["STUDENT_IN_CLASSROOM"] = "STUDENT_IN_CLASSROOM";
    CoTeacherIneligibilityReason["TEACHER_IN_CLASSROOM"] = "TEACHER_IN_CLASSROOM";
})(CoTeacherIneligibilityReason || (CoTeacherIneligibilityReason = {}));
